import React, {useState} from "react"
import {makeStyles} from "@material-ui/core/styles"
import {blue} from "@material-ui/core/colors"
import Typography from "@material-ui/core/Typography"
import Slider from "@material-ui/core/Slider"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import clsx from "clsx"

const useStyles = makeStyles(() => ({
  root: {
    width: `85%`,
    marginTop: `40px`,
    color: blue.A700,
    zIndex: (props) => (props.zIndex === `riseFallBar` ? 1201 : 0),
  },
}))

export default function RiseFallBar() {
  const {t} = useTranslation()
  const {
    store: {zIndex, perspective, mainRiseFallDate, mainTerm},
  } = useStore()
  const classes = useStyles({
    zIndex,
  })
  const {dispatch} = useDispatch()
  const [value, setValue] = useState(20)
  let max = 20
  if (mainTerm[perspective].key === `D20N`) max = 20
  if (mainTerm[perspective].key === `D60N`) max = 60
  if (mainTerm[perspective].key === `D120N`) max = 120
  if (mainTerm[perspective].key === `D250N`) max = 250
  if (mainTerm[perspective].key === `W208N`) max = 208
  if (mainTerm[perspective].key === `M120N`) max = 120
  if (mainTerm[perspective].key === `Q60N`) max = 60
  // const step = mainTerm[perspective].key === `W208N` ? 20 : parseInt(max / 10)

  const valuetext = (date) => `${date}日`
  const changeSilideBar = (event, date) => {
    mainRiseFallDate[perspective] = date
    setValue(date)
    dispatch({
      type: `RISE_FALL_DATE`,
      mainRiseFallDate,
    })
  }
  return (
    <>
      <Slider
        className={clsx(classes.root, `riseFallBar`)}
        value={value}
        min={1}
        max={max}
        getAriaValueText={valuetext}
        valueLabelDisplay="on"
        onChange={changeSilideBar}
        step={1}
      />
      <Typography>{t(`riseFallDate`)}</Typography>
    </>
  )
}
